import React from 'react';
import { Container, Typography, Box, Alert } from '@mui/material';
import ConsultantNavbar from './ConsultantNavbar';

const ConsultantDashboard = () => {
    return (
        <div className="consultant-dashboard-layout">
            <ConsultantNavbar />
            <Container className="consultant-dashboard-content">
                <Box sx={{ my: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom fontWeight={800}>
                        Consultant Dashboard
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Welcome back! Here you can manage student applications, review documents, and coordinate consultation sessions.
                    </Typography>
                    <Alert severity="success" sx={{ mt: 3, borderRadius: 3 }}>
                        Check the "Submissions" tab to see new student applications awaiting review.
                    </Alert>
                </Box>
            </Container>
        </div>
    );
};

export default ConsultantDashboard;
